import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { DownloadOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import cancelarNotaDeCreditoVentaPdf from "../../../../Pdf/cancelarNotaDeCreditoVentaPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//La lista de notas monta este modal dos veces (el suyo y el que abre CancelarNotaDeCreditoVenta
//al terminar de cancelar). antd no desmonta el contenido al cerrar, asi que con un nombre fijo
//habria dos iframes iguales y window.frames[nombre] podria pintar en el que esta oculto.
let contadorIframes = 0;

//Acuse de cancelacion de una nota de credito de venta: mismo modal que el de Ventas
//(Ventas/CancelarVenta/ModalCancelarPdf), con Descargar y Mandar Correo.
class ModalAcuseCancelacionNota extends Component {
  formRef = React.createRef();
  nombreIframe = `acuseCancelacionNotaPdf${++contadorIframes}`;
  state = {
    loading: false,
    datos: null,
    error: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && this.props.visible !== prevProps.visible) {
      this.consultarTodo();
    }
  }

  consultarTodo() {
    this.setState({ loading: true, datos: null, error: null });
    axios
      .post(
        "notasDeCreditoVenta/cancelarNotaDeCreditoVentaPdf",
        { notaId: this.props.notaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({
            loading: false,
            error: res.data.message || "No se pudo consultar el acuse de cancelación",
          });
          return;
        }

        if (res.data.correosEnvio?.length > 0 && this.formRef.current) {
          this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio });
        }

        this.setState({ loading: false, datos: res.data }, () => {
          pdfMake.createPdf(cancelarNotaDeCreditoVentaPdf(res.data)).open({}, window.frames[this.nombreIframe]);
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, error: "No se pudo consultar el acuse de cancelación" });
      });
  }

  cerrarModalPdf() {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({ datos: null, error: null });
    this.props.cerrarModalPdf();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!(values?.correosEnvio?.length > 0)) {
      message.info("Proporcione al menos un correo de envio");
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "notasDeCreditoVenta/enviarCancelacionNotaDeCreditoVenta",
        { ...values, notaId: this.props.notaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Cancelación enviada");
          this.cerrarModalPdf();
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo enviar la cancelación a ese correo");
        } else {
          message.error("Sucedió un error y no se pudo enviar");
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false });
        message.error("Sucedió un error y no se pudo enviar");
      });
  }

  descargarCancelacion() {
    const datos = this.state.datos;
    if (!datos) return;

    const nombreArchivo = (datos.folio || "Nota de credito") + " - Cancelacion";

    if (datos.data?.cancelacion?.acuse) {
      const pom = document.createElement("a");
      const bb = new Blob([datos.data.cancelacion.acuse], { type: "text/plain" });

      pom.setAttribute("href", window.URL.createObjectURL(bb));
      pom.setAttribute("download", (datos.folio || "Nota de credito") + " - Acuse.xml");
      pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
      pom.draggable = true;
      pom.classList.add("dragout");

      pom.click();
    }

    pdfMake.createPdf(cancelarNotaDeCreditoVentaPdf(datos)).download(nombreArchivo + ".pdf");
  }

  render() {
    return (
      <ModalItem
        title="Cancelación de Nota de Crédito"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModalPdf.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoAcuseCancelacionNota"
          layout
          width={700}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                icon={<DownloadOutlined />}
                blanco={true}
                disabled={!this.state.datos}
                onClick={() => this.descargarCancelacion()}
              >
                Descargar
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                disabled={!this.state.datos}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModalPdf.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        {this.state.error ? (
          <div style={{ color: "red", textAlign: "center" }}>
            {this.state.error}
          </div>
        ) : (
          <iframe
            title="Acuse de cancelación de nota de crédito"
            style={{ width: "100%", height: "100vh" }}
            id={this.nombreIframe}
            name={this.nombreIframe}
          />
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalAcuseCancelacionNota);
